import { render, staticRenderFns } from "./PageExploreFamily.vue?vue&type=template&id=67dc3197&scoped=true&"
import script from "./PageExploreFamily.vue?vue&type=script&lang=js&"
export * from "./PageExploreFamily.vue?vue&type=script&lang=js&"
import style0 from "./PageExploreFamily.vue?vue&type=style&index=0&id=67dc3197&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dc3197",
  null
  
)

export default component.exports